module.exports = __webpack_public_path__ + "img/5-1_04.2e48b3d6.jpg";